import React, { FunctionComponent } from 'react'
import { Doughnut } from 'react-chartjs-2'
import { useTranslation } from 'react-i18next'

import { ChartData } from './IProps'
import Style from './style.scss'

export const DoughnutChart: FunctionComponent<ChartData> = ({
    chartLabels,
    results,
}) => {
    const { t } = useTranslation()

    let rawData: number[] = []
    let labelNames: string[] = []
    let labelColors: string[] = []
    let sortAndGroupData: { positive: number[]; negative: number[] }

    if (results) {
        const transformedResults = [...results]
        const transformedLabels = [...chartLabels]

        rawData = transformedResults.map((data) => {
            return data.amount / 100
        })

        labelNames = transformedLabels.map((label) => {
            return label.name
        })

        labelColors = transformedLabels.map((label) => {
            return label.color
        })

        sortAndGroupData = rawData.reduce(
            (acc, val, reduceIndex) => {
                if (val < 0) {
                    const mergeIndex = transformedLabels.findIndex((label) => {
                        let reason = transformedResults[reduceIndex].reason
                        if (reason === null) {
                            reason = t('No reason type')
                        }

                        return label.name === reason
                    })
                    acc.negative[mergeIndex] =
                        (acc.negative[mergeIndex] || 0) + val
                } else {
                    const mergeIndex = transformedLabels.findIndex((label) => {
                        let reason = transformedResults[reduceIndex].reason
                        if (reason === null) {
                            reason = t('No reason type')
                        }

                        return label.name === reason
                    })

                    acc.positive[mergeIndex] =
                        (acc.positive[mergeIndex] || 0) + val
                }
                return acc
            },
            {
                positive: [],
                negative: [],
            }
        )
    }
    // GO OVER ARRAY AND REPLACE EMPTY INDEX WITH VALUE 0
    const negativeSortedData = sortAndGroupData
        ? Array.from(sortAndGroupData?.negative, (val) => val || 0)
        : [0]
    const positiveSortedData = sortAndGroupData
        ? Array.from(sortAndGroupData?.positive, (val) => val || 0)
        : [0]

    const dataIncoming = {
        labels: labelNames,
        datasets: [
            {
                label: '# of Votes',
                data: positiveSortedData,
                backgroundColor: labelColors,
                borderWidth: 1,
            },
        ],
    }

    const dataOutgoing = {
        labels: labelNames,
        datasets: [
            {
                label: '# of Votes',
                data: negativeSortedData,
                backgroundColor: labelColors,
                borderWidth: 1,
            },
        ],
    }

    return (
        <>
            <div className={Style.doughnutWrapper}>
                <div className={Style.doughnutContainer}>
                    <h1>{t('Incoming cash')}</h1>
                    <Doughnut data={dataIncoming} />
                </div>
                <div className={Style.doughnutContainer}>
                    <h1>{t('Withdraw cash')}</h1>
                    <Doughnut data={dataOutgoing} />
                </div>
            </div>
        </>
    )
}
